import ActiveLink from "@/components/ActiveLink";
import AccountMetaTags from "@/components/MetaTags/AccountMetaTags";
import { useAuthUserQuery, useBreadcrumbs, useRequireLogin } from "@/hooks";
import routes from "@/lib/routes";
import styles from "@/styles/Account.module.scss";
import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";
import AccountInfo from "../../components/Account/accountInfo";
import PaymentHistory from "../../components/Account/paymentHistory";
import PaymentMethod from "../../components/Account/paymentMethod";
import Product from "../../components/Account/product";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;
export default function Account(props) {
  var _data$user;
  useRequireLogin({
    ownerOnly: true
  });
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  useEffect(() => {
    setBreadcrumbs([{
      text: "ホーム",
      href: routes.home
    }, {
      text: "アカウント",
      href: routes.account
    }]);
  }, []);
  const {
    data
  } = useAuthUserQuery({
    variables: {}
  });
  const router = useRouter();
  const ownerProfile = data === null || data === void 0 || (_data$user = data.user) === null || _data$user === void 0 || (_data$user = _data$user.currentProfile) === null || _data$user === void 0 ? void 0 : _data$user.ownerProfile;
  useEffect(() => {
    if (!ownerProfile) {
      router.push(routes.home);
    }
  }, [ownerProfile]);
  const action = useMemo(() => {
    if (router.asPath === routes.account) {
      return "index";
    } else if (router.asPath === routes.accountProduct) {
      return "product";
    } else if (router.asPath === routes.accountPaymentMethod) {
      return "paymentmethod";
    } else if (router.asPath === routes.accountPaymentHistory) {
      return "paymenthistory";
    }
  }, [router.asPath]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AccountMetaTags, {
      action: action
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.accountContainer,
      children: [/*#__PURE__*/_jsx("h2", {
        className: styles.pageTitle,
        children: "\u30A2\u30AB\u30A6\u30F3\u30C8"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.accountHeader,
        children: /*#__PURE__*/_jsx("nav", {
          className: styles.accountNav,
          children: /*#__PURE__*/_jsx("div", {
            className: styles.accountNavInner,
            children: /*#__PURE__*/_jsxs("ul", {
              className: styles.slideItems,
              children: [/*#__PURE__*/_jsx("li", {
                className: styles.slideItem,
                children: /*#__PURE__*/_jsx(ActiveLink, {
                  href: routes.account,
                  shallow: true,
                  children: /*#__PURE__*/_jsx("a", {
                    className: styles.link,
                    children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u60C5\u5831"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                className: styles.slideItem,
                children: /*#__PURE__*/_jsx(ActiveLink, {
                  href: routes.accountProduct,
                  shallow: true,
                  children: /*#__PURE__*/_jsx("a", {
                    className: styles.link,
                    children: "\u3054\u5229\u7528\u72B6\u6CC1"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                className: styles.slideItem,
                children: /*#__PURE__*/_jsx(ActiveLink, {
                  href: routes.accountPaymentMethod,
                  shallow: true,
                  children: /*#__PURE__*/_jsx("a", {
                    className: styles.link,
                    children: "\u304A\u652F\u6255\u3044\u65B9\u6CD5"
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                className: styles.slideItem,
                children: /*#__PURE__*/_jsx(ActiveLink, {
                  href: routes.accountPaymentHistory,
                  shallow: true,
                  children: /*#__PURE__*/_jsx("a", {
                    className: styles.link,
                    children: "\u304A\u652F\u6255\u3044\u5C65\u6B74"
                  })
                })
              })]
            })
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.accountContents,
        children: [router.asPath === routes.account && /*#__PURE__*/_jsx(AccountInfo, {
          isUid2Data: props.isUid2Data
        }), router.asPath === routes.accountProduct && /*#__PURE__*/_jsx(Product, {}), router.asPath === routes.accountPaymentMethod && /*#__PURE__*/_jsx(PaymentMethod, {}), router.asPath === routes.accountPaymentHistory && /*#__PURE__*/_jsx(PaymentHistory, {})]
      })]
    })]
  });
}